import { createFont, createTamagui, createTokens } from 'tamagui';

import { kindredMedia } from './media';
import { kindredDefaultTheme, kindredThemes } from './themes';
import {
  kindredBodyWeightTokens,
  kindredColorTokens,
  kindredFontFamilies,
  kindredHeadingWeightTokens,
  kindredLetterSpacingTokens,
  kindredLineHeightTokens,
  kindredRadiusTokens,
  kindredSizeTokens,
  kindredSpaceTokens,
  kindredZIndexTokens,
} from './tokens';

const headingFontFamily =
  kindredFontFamilies.display === '__kindred_display__' ? 'Manrope' : kindredFontFamilies.display;

const bodyFont = createFont({
  family: kindredFontFamilies.sans,
  size: kindredSizeTokens,
  lineHeight: kindredLineHeightTokens,
  weight: kindredBodyWeightTokens,
  letterSpacing: kindredLetterSpacingTokens,
});

const headingFont = createFont({
  family: headingFontFamily,
  size: kindredSizeTokens,
  lineHeight: kindredLineHeightTokens,
  weight: kindredHeadingWeightTokens,
  letterSpacing: kindredLetterSpacingTokens,
});

export const kindredTokens = createTokens({
  color: kindredColorTokens,
  space: kindredSpaceTokens,
  size: kindredSizeTokens,
  radius: kindredRadiusTokens,
  zIndex: kindredZIndexTokens,
});

export const kindredTamaguiConfig = createTamagui({
  tokens: kindredTokens,
  themes: kindredThemes,
  media: kindredMedia,
  fonts: {
    body: bodyFont,
    heading: headingFont,
  },
  shorthands: {
    ai: 'alignItems',
    bg: 'backgroundColor',
    br: 'borderRadius',
    bw: 'borderWidth',
    fd: 'flexDirection',
    gap: 'gap',
    jc: 'justifyContent',
    m: 'margin',
    mb: 'marginBottom',
    ml: 'marginLeft',
    mr: 'marginRight',
    mt: 'marginTop',
    mx: 'marginHorizontal',
    my: 'marginVertical',
    p: 'padding',
    pb: 'paddingBottom',
    pl: 'paddingLeft',
    pr: 'paddingRight',
    pt: 'paddingTop',
    px: 'paddingHorizontal',
    py: 'paddingVertical',
  },
  settings: {
    defaultFont: 'body',
    themeClassNameOnRoot: true,
  },
  defaultTheme: kindredDefaultTheme,
});

export type KindredTamaguiConfig = typeof kindredTamaguiConfig;

declare module 'tamagui' {
  interface TamaguiCustomConfig extends KindredTamaguiConfig {}
}

export default kindredTamaguiConfig;
